import { categories } from "@/mocks/comics";

const categoryIcons = [
  "ri-sword-line",
  "ri-building-2-line",
  "ri-rocket-2-line",
  "ri-basketball-line",
  "ri-heart-3-line",
  "ri-search-eye-line",
  "ri-ghost-line",
  "ri-emotion-laugh-line",
  "ri-drag-move-2-line",
  "ri-global-line",
];

export default function Categories() {
  return (
    <section id="category" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 md:mb-10">
          <div>
            <span className="inline-flex items-center gap-1.5 text-secondary-700 text-sm font-medium">
              <i className="ri-grid-line" />
              CATEGORIES
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-950">题材分类，想追就追</h2>
            <p className="mt-2 text-sm md:text-base text-foreground-600">按题材快速找到你喜欢的漫画，热门分类更新不断</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat, index) => (
            <a
              key={cat.name}
              href="#category"
              className="group rounded-xl bg-background-50 border border-background-200 p-5 md:p-6 flex flex-col transition-all duration-300 hover:border-primary-300 hover:-translate-y-1 cursor-pointer"
            >
              <span className="flex items-center justify-center w-11 h-11 md:w-12 md:h-12 rounded-lg bg-secondary-100 text-secondary-900 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${categoryIcons[index % categoryIcons.length]} text-xl`} />
              </span>
              <h3 className="mt-4 font-medium text-foreground-950">{cat.name}</h3>
              <p className="mt-1 text-xs md:text-sm text-foreground-600">{cat.desc}</p>
              <span className="mt-3 text-xs text-foreground-500">{cat.count} 部作品</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}